

// import React, { useState } from "react";
// import {
//   Box,
//   Button,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   TextField,
//   Typography,
//   CircularProgress,
//   Alert,
// } from "@mui/material";
// import SendIcon from "@mui/icons-material/Send";
// import axios from "axios";

// export default function InformationalSMS({ open, onClose }) {
//   const [message, setMessage] = useState("");
//   const [loading, setLoading] = useState(false);
//   const [alert, setAlert] = useState({ type: "", text: "" });

//   const handleSend = async () => {
//     if (!message.trim()) {
//       setAlert({ type: "error", text: "Please enter a message first." });
//       return;
//     }

//     setLoading(true);
//     setAlert({ type: "", text: "" });

//     try {
//       // Send the message to your backend API
//       await axios.post(
//         `${process.env.REACT_APP_API_BASE_URL}/Appointment/send-marketing-messages`,
//         { message } // send as JSON body
//       );
//       setAlert({ type: "success", text: "Promotional SMS sent successfully!" });
//       setMessage("");
//     } catch (error) {
//       console.error(error);
//       setAlert({
//         type: "error",
//         text: "Failed to send SMS. Please try again later.",
//       });
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <Dialog
//       open={open}
//       onClose={onClose}
//       maxWidth="sm"
//       fullWidth
//       PaperProps={{
//         sx: { borderRadius: 3, p: 1.5, backgroundColor: "#fff" },
//       }}
//     >
//       <DialogTitle
//         sx={{
//           textAlign: "center",
//           fontWeight: "bold",
//           color: "primary",
//           fontSize: "1.4rem",
//         }}
//       >
//         Send Informational SMS
//       </DialogTitle>

//       <DialogContent>
//         {alert.text && (
//           <Alert
//             severity={alert.type}
//             sx={{
//               mb: 2,
//               borderRadius: 2,
//               backgroundColor:
//                 alert.type === "success" ? "#2e7d32" : "#d32f2f",
//               color: "white",
//             }}
//           >
//             {alert.text}
//           </Alert>
//         )}

//         <Typography variant="body2" sx={{ mb: 1, color: "#555" }}>
//           Enter your Informational message below
//         </Typography>

//         <TextField
//           label="Message"
//           fullWidth
//           multiline
//           rows={4}
//           value={message}
//           onChange={(e) => setMessage(e.target.value)}
//           variant="outlined"
//           sx={{
//             "& .MuiOutlinedInput-root": {
//               "& fieldset": { borderColor: "Primary" },
//               "&:hover fieldset": { borderColor: "Primary" },
//               "&.Mui-focused fieldset": { borderColor: "Primary" },
//             },
//             "& .MuiInputLabel-root": { color: "Primary" },
//           }}
//         />
//       </DialogContent>

//       <DialogActions sx={{ justifyContent: "center", p: 2 }}>
//         <Button
//           onClick={onClose}
//           variant="outlined"
//           sx={{
//             borderColor: "Primary",
//             color: "Primary",
//             fontWeight: "bold",
//             "&:hover": {
//               borderColor: "Primary",
//               color: "Primary",
//             },
//           }}
//         >
//           Cancel
//         </Button>

//         <Button
//           variant="contained"
//           onClick={handleSend}
//           disabled={loading}
//           sx={{
           
//             color: "white",
//             fontWeight: "bold",
//             borderRadius: 2,
//             "&:hover": { backgroundColor: "Primary" },
//           }}
//           endIcon={loading ? <CircularProgress size={20} /> : <SendIcon />}
//         >
//           {loading ? "Sending..." : "Send"}
//         </Button>
//       </DialogActions>
//     </Dialog>
//   );
// }


import React, { useState } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Typography,
  CircularProgress,
  Alert,
} from "@mui/material";
import SendIcon from "@mui/icons-material/Send";
import axios from "axios";

export default function InformationalSMS({ open, onClose }) {
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [alert, setAlert] = useState({ type: "", text: "" });

  // NEW STATE – selected numbers
  const [selectedContacts, setSelectedContacts] = useState([]);

  // EXISTING FUNCTION (Marketing SMS)
  const handleSend = async () => {
    if (!message.trim()) {
      setAlert({ type: "error", text: "Please enter a message first." });
      return;
    }

    setLoading(true);
    setAlert({ type: "", text: "" });

    try {
      await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/Appointment1/send-marketing-messages`,
        { message }
      );

      setAlert({ type: "success", text: "Promotional SMS sent successfully!" });
      setMessage("");
    } catch (error) {
      console.error(error);
      setAlert({
        type: "error",
        text: "Failed to send SMS. Please try again later.",
      });
    } finally {
      setLoading(false);
    }
  };

  // ✅ NEW FUNCTION – Send Custom SMS to Selected Contacts
  const handleSendCustom = async () => {
    if (!message.trim()) {
      setAlert({ type: "error", text: "Please enter a message first." });
      return;
    }

    if (!selectedContacts.length) {
      setAlert({ type: "error", text: "Please select at least one contact." });
      return;
    }

    setLoading(true);
    setAlert({ type: "", text: "" });

    try {
      await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/Appointment/send-custom-messages`,
        {
          Message: message,
          Contacts: selectedContacts,
        }
      );

      setAlert({ type: "success", text: "SMS sent successfully!" });
      setMessage("");
      setSelectedContacts([]);
    } catch (error) {
      console.error(error);
      setAlert({
        type: "error",
        text: "Failed to send SMS. Please try again later.",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: { borderRadius: 3, p: 1.5, backgroundColor: "#fff" },
      }}
    >
      <DialogTitle
        sx={{
          textAlign: "center",
          fontWeight: "bold",
          fontSize: "1.4rem",
        }}
      >
        Send Informational SMS
      </DialogTitle>

      <DialogContent>
        {alert.text && (
          <Alert severity={alert.type} sx={{ mb: 2, borderRadius: 2 }}>
            {alert.text}
          </Alert>
        )}

        <Typography variant="body2" sx={{ mb: 1, color: "#555" }}>
          Enter your message below
        </Typography>

        <TextField
          label="Message"
          fullWidth
          multiline
          rows={4}
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          variant="outlined"
        />

        {/* Example input for manually adding numbers (comma separated) */}
        <TextField
          label="Selected Numbers (comma separated)"
          fullWidth
          sx={{ mt: 2 }}
          onChange={(e) =>
            setSelectedContacts(
              e.target.value.split(",").map((num) => num.trim())
            )
          }
        />
      </DialogContent>

      <DialogActions sx={{ justifyContent: "center", p: 2 }}>
        <Button onClick={onClose} variant="outlined">
          Cancel
        </Button>

        {/* Existing Marketing SMS */}
        <Button
          variant="contained"
          onClick={handleSend}
          disabled={loading}
          endIcon={loading ? <CircularProgress size={20} /> : <SendIcon />}
        >
          Send Marketing
        </Button>

        {/* ✅ New Custom SMS Button */}
        <Button
          variant="contained"
          color="success"
          onClick={handleSendCustom}
          disabled={loading}
          endIcon={loading ? <CircularProgress size={20} /> : <SendIcon />}
        >
          Send Selected
        </Button>
      </DialogActions>
    </Dialog>
  );
}